<template>
    <div class="maintenance-page-component-container">
        <div class="component-wrapper">
            <div class="maintenance-page-container">
                <div class="maintenance-text-container">
                    <p>{{ $t('application_under_construction') }}</p>
                </div>
            </div>

            <LoginFooter />
        </div>
    </div>
</template>

<script>
import LoginFooter from './login/LoginFooter.vue';
export default {
    name: 'MaintenancePage',
    components: {
        LoginFooter,
    },
    data() {
        return ;
    },
}
</script>

<style>
.maintenance-page-component-container {
    position: relative;
    height: 100vh;
    width: 100%;
}

.maintenance-page-component-container .component-wrapper {
    height: 100vh;
    display: flex;
    flex-direction: column;
}

.maintenance-page-component-container .maintenance-page-container {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: auto;
}

.maintenance-page-component-container .maintenance-text-container p {
    font-size: 38px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #92d400;
    text-align: center;
    line-height: 35px;
}

@media (max-width: 768px) {
    .maintenance-page-component-container .maintenance-text-container p {
        font-size: calc(10px + 3vw);
    }
}

@media (max-width: 550px) {
    .maintenance-page-component-container .maintenance-text-container p {
        font-size: calc(10px + 2.5vw);
    }
}

@media (max-width: 425px) {
    .maintenance-page-component-container .maintenance-text-container p {
        font-size: calc(20px + 1vw);
    }
}

@media (max-width: 320px) {
    .maintenance-page-component-container .maintenance-text-container p {
        font-size: calc(16px + 1vw);
    }
}
</style>